import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAdminContext } from '../../../context/AdminContext';
import Axios from '../../../Axios';
import Loader from '../../../utils/Loader/Loader';
import Card from '../../utils/Card/Card';
import Popup from '../../../utils/Popup/Popup';
import FileUploader from '../../utils/FileUploader/FileUploader';
import MyInput from '../../../ui/MyInput/MyInput';

const HomeCarouselForm = () => {
  const { id } = useParams();
  const { adminConfig } = useAdminContext();

  const [data, setData] = useState({});
  const [imageFile, setImageFile] = useState();
  const [mobileImageFile, setMobileImageFile] = useState();
  const [eyebrow, setEyebrow] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const [isLoading, setIsLoading] = useState(true);
  const [btnIsLoading, setBtnIsLoading] = useState(false);

  const [popupType, setPopupType] = useState('');
  const [popupText, setPopupText] = useState('');
  const [visiblePopup, setVisiblePopup] = useState(false);

  useEffect(() => {
    if (id) {
      Axios.get(`/fopperies/${id}`, adminConfig)
        .then((res) => {
          setData(res.data);
          setEyebrow(res.data.eyebrow || '');
          setTitle(res.data.title || '');
          setDescription(res.data.description || '');
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);

          setPopupType('sys_error');
          setPopupText('');
          setVisiblePopup(true);
        });
    } else {
      setIsLoading(false);
      setData({});
    }
  }, [id, adminConfig]);

  const createHandler = (formData) => {
    formData.append('imageFile', imageFile);
    formData.append('mobileImageFile', mobileImageFile);
    formData.append('eyebrow', eyebrow);
    formData.append('title', title);
    formData.append('description', description);

    Axios.post('/fopperies/banner', formData, {
      headers: {
        token: adminConfig.headers.token
      }
    })
      .then((res) => {
        if (res.data.message === 'success') {
          window.location.replace('/admin/home-carousels');
        } else {
          setPopupType('sys_error');
          setVisiblePopup(true);
        }
      })
      .catch(() => {
        setPopupType('sys_error');
        setVisiblePopup(true);
      });
  };

  const editHandler = (formData) => {
    formData.append('id', id);
    formData.append('image', data.image);
    formData.append('mobile_image', data.mobile_image);
    formData.append('imageFile', imageFile);
    formData.append('mobileImageFile', mobileImageFile);
    formData.append('eyebrow', eyebrow);
    formData.append('title', title);
    formData.append('description', description);

    Axios.put('/fopperies/banner', formData, adminConfig)
      .then((res) => {
        if (res.data.message === 'success') {
          window.location.reload();
        } else {
          setPopupType('sys_error');
          setPopupText('');
          setVisiblePopup(true);
        }
      })
      .catch(() => {
        setPopupType('sys_error');
        setPopupText('');
        setVisiblePopup(true);
      });
  };

  const saveHandler = () => {
    setBtnIsLoading(true);

    const formData = new FormData();

    if (id) {
      editHandler(formData);
    } else {
      createHandler(formData);
    }
  };

  return isLoading ? (
    <Loader />
  ) : (
    <Card centered>
      <Popup
        messageType={popupType}
        messageText={popupText}
        visible={visiblePopup}
        onOk={() => window.location.reload()}
      />

      <FileUploader file={data.image} getFile={setImageFile} />
      <div style={{ marginTop: 12 }}>
        <label style={{ display: 'block', marginBottom: 8 }}>Мобайл зураг:</label>
        <FileUploader file={data.mobile_image} getFile={setMobileImageFile} />
      </div>

      <div style={{ width: 460, maxWidth: '100%', marginTop: 12 }}>
        <MyInput
          label='Дээд текст'
          name='eyebrow'
          value={eyebrow}
          onChange={(e) => setEyebrow(e.target.value)}
          placeholder='ПРЕМИУМ СУРГАЛТ'
        />

        <MyInput
          label='Гарчиг'
          name='title'
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Ochiroo's Theory"
        />

        <MyInput
          label='Тайлбар'
          name='description'
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          isTextarea
          rows={3}
          placeholder='10+ жилийн судалгааны үр дүн бий болсон дэлхийд гарах оюун.'
        />
      </div>

      <center style={{ marginTop: 10 }}>
        {btnIsLoading ? (
          <Loader mini />
        ) : (
          <button onClick={saveHandler}>Хадгалах</button>
        )}
      </center>
    </Card>
  );
};

export default HomeCarouselForm;
